export default __webpack_public_path__ + "static/media/AI.f4ad90d4.png";